import { MapPrintContent as View } from "ui-components";

import { Map } from "~map-view/views/map-view/map";

export const MapPrintContent = () => {
	return (
		<View>
			<Map />
		</View>
	);
};
